import React from "react";
// import ZenGanttChart from "../ManagerDashboard/Common/Graph/ZenGanttChart";
import ZenVerBarChart from "../ManagerDashboard/Common/Graph/ZenVerBarChart";

import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import {  Row, Col } from "antd";
class SbPlantTopVariationParts extends React.Component {
  state = {
    ZenGanttChart:null,
    loading: true,
    loginError: false,
    lid: "all",
    selectedMnt: "all",
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.fetchTrendData()
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid = "all", mnt = "all") => {
    liracrypt
      .get("/sb/dashboard/chartdata",this.props.urlData || {})
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["TopVariationD0"] = resp["data"]["TopVariationD0"];
        respData["TopVariationD1"] = resp["data"]["TopVariationD1"];
        respData["TopVariationD0"] = resp["data"]["TopVariationD0"];
        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <div>

<Row style={{   background: "#000000"}} >
            <Col span={8}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                <ZenVerBarChart
                  divId={"R2C1"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.TopVariationD0.data}
                  config={this.state.TopVariationD0.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            <Col span={8}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                <ZenVerBarChart
                  divId={"R2C2"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.TopVariationD1.data}
                  config={this.state.TopVariationD1.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            <Col span={8}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                <ZenVerBarChart
                  divId={"R2C3"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.TopVariationD0.data}
                  config={this.state.TopVariationD0.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            
 
           
          </Row>


        </div>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}
export default SbPlantTopVariationParts;